import { logger } from '$utils'
import { defer } from 'react-router-dom'
import { mercuryApi } from '$api'
import { Connection } from './types'

export default async function loader() {
  logger.debug(
    '[loader] About to await AppState being ready in Company Connections loader'
  )

  // Fetch all connections from the new /connections endpoint
  const connectionsPromise = mercuryApi
    .get<Connection[]>('/connections')
    .catch((error) => {
      logger.error('Failed to fetch connections: %o', error)
      return [] as Connection[]
    })

  return defer({
    data: connectionsPromise,
  })
}
